import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { IndicatorChartTypeEnums } from 'src/app/enum/indicator-chart-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { RemissionOrderStateEnum } from 'src/app/enum/remission-order-state-enum';
import { ServiceStateEnums } from 'src/app/enum/service-state-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { IndicatorChart } from 'src/app/interfaces/custom-indicators/indicator-chart.interface';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ItemChartModel } from 'src/app/models/charts/global/item-chart.model';
import { ServiceChartModel } from 'src/app/models/charts/rental/service-chart.model';
import { ServiceDetailTableModel } from 'src/app/models/rental/service-detail-table.model';
import { ServiceTableModel } from 'src/app/models/rental/service-table.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceServiceTableModel } from 'src/app/models/tables/rental/invoice-service-table.model';
import { RemissionFromOrderTableModel } from 'src/app/models/tables/rental/remission-from-order-table.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { RemissionFromOrderService } from 'src/app/services/rental/remission-from-order.service';
import { ServiceDetailService } from 'src/app/services/rental/service-detail.service';
import { ServiceService } from 'src/app/services/rental/service.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { OrderDataComponent } from '../../remission-detail/order-data/order-data.component';

const ServiceIndicatorsConstants = {
  states: [
    { id: ServiceStateEnums.abierto, label: 'Abiertos', color: '#EF4444' },
    { id: ServiceStateEnums.impreso, label: 'Impresos', color: '#3B82F6' },
    { id: ServiceStateEnums.cerrado, label: 'Cerrados', color: '#198754' },
    { id: ServiceStateEnums.anulado, label: 'Anulados', color: '#FB923C' }
  ]
};

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],
  standalone: false
})
export class ServiceComponent implements OnInit, OnDestroy {

  @ViewChild('orderDataModal') orderDataModalComponent?: CustomModalComponent | null = null;

  activeTabIndex: number = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  componentOrderData = OrderDataComponent;
  detailData: PagedResponseModel<ServiceDetailTableModel> = new PagedResponseModel<ServiceDetailTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  filters: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<ServiceTableModel> = new PagedResponseModel<ServiceTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  indicatorCharts: IndicatorChart[] = this.buildIndicatorCharts(new ServiceChartModel());
  indicatorsRequestId: number = 0;
  inputsForOrderDataModal$ = new BehaviorSubject<any>({
    orderId: 0
  });
  invoiceData: PagedResponseModel<InvoiceServiceTableModel> = new PagedResponseModel<InvoiceServiceTableModel>();
  invoiceHeader: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listObservers: Array<Subscription> = new Array<Subscription>();
  listRemissionOrderState: ColumnResponseModel = new ColumnResponseModel();
  loadingIndicators: boolean = false;
  nameWindow: string = 'Servicios';
  origin: WindowEnums = WindowEnums.Service;
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  remissionFromOrderActions: TableAction[] = [
    {
      label: 'Datos del pedido',
      icon: 'pi pi-info-circle',
      action: 'order-data'
    }
  ];
  remissionFromOrderData: PagedResponseModel<RemissionFromOrderTableModel> = new PagedResponseModel<RemissionFromOrderTableModel>();
  remissionFromOrderHeader: FilterGlobalResponseModel = new FilterGlobalResponseModel();
  remissionOrderState: RemissionOrderStateEnum = RemissionOrderStateEnum.pending;
  selected: boolean = false;
  serviceId: number = 0;
  swOrderModule: boolean = false;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = "";
  userAuthenticated: UserModel = new UserModel();

  constructor(private optionWindowService: OptionWindowService,
    private router: Router,
    private serviceDetailService: ServiceDetailService,
    private serviceService: ServiceService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private remissionFromOrderService: RemissionFromOrderService,
    private userAuthenticatedService: UserAuthenticatedService,
    private headerService: HeaderService,
    private windowService: WindowService) {
    this.getPermission();
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem('service');
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getServicesWithPagination(),
      this.getGeneralParametersByCompany(),
      this.getIndicatorsForGeneralConsultation()
    ]);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  buildIndicatorCharts(indicators: ServiceChartModel): IndicatorChart[] {
    const { states } = ServiceIndicatorsConstants;
    return [
      {
        type: IndicatorChartTypeEnums.donut,
        title: 'Servicios por estado',
        labels: states.map(state => state.label),
        values: states.map(state => this.getIndicatorQuantity(indicators.states, state.id)),
        colors: states.map(state => state.color),
        total: indicators.total
      }
    ];
  }

  createNewService() {
    if (this.permissionUpdatable) {
      this.router.navigate(['/service/register']);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear servicios. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async exportDetailsConsultation() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador ||
      this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(this.serviceDetailService.exportGeneralConsultation(
          this.filters, this.columnSort, this.ascendant)
        );
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'ServiciosDetalles.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error to export detail services.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar detalle de servicios, comuniquese con el administrador del sistema.'
      );
    }
  }

  async exportGeneralConsultation() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador ||
      this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(this.serviceService.exportGeneralConsultation(
          this.filters, this.columnSort, this.ascendant)
        );
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Servicios.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error to export services.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar servicios, comuniquese con el administrador del sistema.'
      );
    }
  }

  async exportRemissionFromOrderConsultation() {
    try {
      const blob = await firstValueFrom(this.remissionFromOrderService.exportRemissionFromOrderConsultation(
        this.filters, this.columnSort, this.ascendant, this.remissionOrderState, this.origin)
      );
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Pedidos Detalle.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar los pedidos detalle.', error);
    }
  }

  async exportInvoiceForSuspensionConsultation() {
    try {
      const blob = await firstValueFrom(this.serviceService.exportInvoiceForServiceConsultation(
        this.filters, this.columnSort, this.ascendant)
      );
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Servicios Facturas.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar las facturas de servicios detalle.', error);
    }
  }

  async getAllRemissionFromOrderWithPagination() {
    try {
      this.remissionFromOrderData = await firstValueFrom(this.remissionFromOrderService.getAllRemissionFromOrderWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.remissionOrderState, this.origin, this.filters)
      );
    } catch (error) {
      console.error('Error al buscar las remisiones.', error);
    }
  }

  async getAllInvoiceForServicesWithPagination() {
    try {
      this.invoiceData = await firstValueFrom(this.serviceService.getAllInvoiceForServicesWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters)
      );
    } catch (error) {
      console.error('Error al buscar las facturas para los servicios.', error);
    }
  }

  async getColumnsForDetailsConsultation() {
    try {
      if (this.detailHeader.length === 0) {
        this.detailHeader = await firstValueFrom(this.serviceDetailService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error to search columns for query.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.serviceService.getColumnsForGeneralConsultation());
      }
      this.listRemissionOrderState = new ColumnResponseModel;
    } catch (error) {
      console.error('Error to search columns for general query.', error);
    }
  }

  async getColumnsForRemissionFromOrderConsultation() {
    try {
      if (this.remissionFromOrderHeader.columns.length === 0) {
        this.remissionFromOrderHeader = await firstValueFrom(this.remissionFromOrderService.getColumnsForRemissionFromOrderConsultation());
      }
      this.listRemissionOrderState = this.remissionFromOrderHeader.filtersGlobal[0];
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getColumnsForInvoiceConsultation() {
    try {
      if (this.invoiceHeader.length === 0) {
        this.invoiceHeader = await firstValueFrom(this.serviceService.getColumnsForInvoiceConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta de facturas.', error);
    }
  }

  async getDetailsWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.serviceDetailService.getAllServiceDetailsWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters
      ));
    } catch (error) {
      console.error('Error to search details service.', error);
    }
  }

  async getIndicatorsForGeneralConsultation() {
    // Descarta respuestas de solicitudes anteriores que lleguen después de la última
    const requestId = ++this.indicatorsRequestId;
    this.loadingIndicators = true;
    try {
      const indicators = await firstValueFrom(this.serviceService.getIndicatorsForGeneralConsultation(this.filters));
      if (requestId === this.indicatorsRequestId) {
        this.indicatorCharts = this.buildIndicatorCharts(indicators);
      }
    } catch (error) {
      console.error('Error al buscar los indicadores de los servicios.', error);
    } finally {
      if (requestId === this.indicatorsRequestId)
        this.loadingIndicators = false;
    }
  }

  getIndicatorQuantity(items: ItemChartModel[], id: number): number {
    return items?.find(item => item.id === id)?.quantity ?? 0;
  }

  async getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swOrderModule = response.some(x => x.name === GeneralParameters.orderModule);
    });
    this.listObservers.push(load);
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error to get permission profile by URL.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Service));
  }

  async getServicesWithPagination() {
    try {
      this.generalData = await firstValueFrom(this.serviceService.getAllServicesWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters
      ));
    } catch (error) {
      console.error('Error to search services.', error);
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.length = this.detailHeader.length === 1 ? 0 : this.detailHeader.length;
    this.invoiceHeader.length = this.invoiceHeader.length === 1 ? 0 : this.invoiceHeader.length;
    this.remissionFromOrderHeader.columns.length = this.remissionFromOrderHeader.columns.length === 1 ? 0
      : this.remissionFromOrderHeader.columns.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getServicesWithPagination(),
          this.getIndicatorsForGeneralConsultation()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailsConsultation(),
          this.getDetailsWithPagination()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 2:
        await Promise.all([
          this.getColumnsForRemissionFromOrderConsultation(),
          this.getAllRemissionFromOrderWithPagination()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 3:
        await Promise.all([
          this.getColumnsForInvoiceConsultation(),
          this.getAllInvoiceForServicesWithPagination()
        ]);
        this.invoiceData = {
          ...this.invoiceData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  onAction(event: { action: string, item?: any, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) { this.router.navigate([`/service/register/${event.item.id}`]); }
    if (event.action === 'order-data' && event.item) { this.openOrderDataModal(event.item.orderId); }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailsConsultation();
        break;
      case 2:
        await this.exportRemissionFromOrderConsultation();
        break;
      case 3:
        await this.exportInvoiceForSuspensionConsultation();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getServicesWithPagination()
        break;
      case 1:
        await this.getDetailsWithPagination()
        break;
      case 2:
        await this.getAllRemissionFromOrderWithPagination();
        break;
      case 3:
        await this.getAllInvoiceForServicesWithPagination()
        break;
    }
  }

  onRemissionOrderStateChange(value: number) {
    this.remissionOrderState = value;
  }

  openOrderDataModal(orderId: number) {
    this.inputsForOrderDataModal$.next({
      orderId: orderId
    });
    this.orderDataModalComponent?.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

}
